import { MdAddBox } from "react-icons/md";
import { RiDashboardFill } from "react-icons/ri";
import { FaBoxes, FaCalculator, FaReceipt } from "react-icons/fa";
import { LuPackageSearch } from "react-icons/lu";
import { SiNdr } from "react-icons/si";
import { IoNotifications, IoSettingsSharp, IoWallet } from "react-icons/io5";
import { BiSolidReceipt } from "react-icons/bi";
import { TbHelpSquareRoundedFilled } from "react-icons/tb";
import { AiOutlineNodeIndex } from "react-icons/ai";
import { TfiStatsUp } from "react-icons/tfi";
import { FaBox } from "react-icons/fa";
import { faker } from "@faker-js/faker";

export const SidebarMenu = {
  primary: [
    {
      title: "Dashboard",
      path: "/",
      icon: RiDashboardFill,
    },
    {
      title: "New Booking",
      path: "newBooking",
      icon: MdAddBox,
    },
    {
      title: "Booked Orders",
      path: "bookedOrders",
      icon: FaBoxes,
    },
  ],
  secondary: [
    {
      title: "Tracking",
      path: "tracking",
      icon: LuPackageSearch,
    },
    {
      title: "Wallet",
      path: "wallet",
      icon: IoWallet,
    },
    {
      title: "NDR",
      path: "ndr",
      icon: SiNdr,
    },
    {
      title: "Billing",
      path: "billing",
      icon: FaReceipt,
    },
    {
      title: "Reports",
      path: "reports",
      icon: BiSolidReceipt,
    },
    {
      title: "Settings",
      path: "settings",
      icon: IoSettingsSharp,
    },
    {
      title: "Support",
      path: "support",
      icon: TbHelpSquareRoundedFilled,
    },
  ],
  ternary: [
    {
      title: "Check Serviceability",
      path: "checkServiceability",
      icon: AiOutlineNodeIndex,
    },
    {
      title: "Rate Calculator",
      path: "rateCalculator",
      icon: FaCalculator,
    },
    {
      title: "Notifications",
      path: "notifications",
      icon: IoNotifications,
    },
  ],
};

export const StatsShipment = [
  { statusName: "Total Shipments", statusNumber: 1672 },
  { statusName: "Booked", statusNumber: 1672 },
  { statusName: "Pending Booking", statusNumber: 1672 },
  { statusName: "In-Transit", statusNumber: 1672 },
  { statusName: "Delivered", statusNumber: 1672 },
];

export const StatsNdr = [
  { statusName: "Total NDR", statusNumber: 1672 },
  { statusName: "Action Requires", statusNumber: 1672 },
  { statusName: "Action Requested", statusNumber: 1672 },
  { statusName: "Delivered", statusNumber: 1672 },
  { statusName: "RTO", statusNumber: 1672 },
];

export const StatsCod = [
  { statusName: "Total Remitted", statusNumber: 1672 },
  { statusName: "Last Remittance", statusNumber: 1672 },
  { statusName: "Next Remittance", statusNumber: 1672 },
  { statusName: "Total Remitted Due", statusNumber: 1672 },
];

export const DeliveryInfoData = [
  {
    type: "icon",
    title: "Total Revenue",
    subtitle: "Total value of delivered orders (in Rs.)",
    icon: TfiStatsUp,
    value: "46,36,266.90",
  },
  {
    type: "icon",
    title: "Avg. Order Cost ",
    subtitle: "Your average shipping cost of all orders",
    icon: FaBox,
    value: "46.50",
  },
  {
    type: "progress",
    title: "Delivered Percentage ",
    subtitle: "Total orders delivered (in percentage)",
    current: 151,
    total: 170,
    label: "orders delivered",
  },
];

export const getBookedOrderData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      id: index + 1, // Unique ID for DataTable
      channel: faker.helpers.arrayElement([
        "Shopify",
        "WooCommerce",
        "Amazon",
        "Custom",
      ]),
      orderId: faker.string.numeric(12), // Generates a 12-digit numeric Order ID
      orderDate: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
      productName: faker.commerce.productName(),
      payment: faker.finance.amount(),
      collectableAmount: faker.number.int({ min: 100, max: 5000 }), // Generates a whole number
      paymentMode: faker.helpers.arrayElement(["COD", "Prepaid"]),
      customer: faker.person.fullName(),
      zipCode: faker.string.numeric(6), // Ensures exactly 6 digits for Zip Code
      weight: faker.finance.amount({ min: 0.5, max: 50, dec: 2 }), // Generates weight with 2 decimal places
      status: faker.helpers.arrayElement(["Booked", "NotBooked"]),
    };
  });
};

export const getTrackingOrderData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      id: index + 1,
      channel: faker.helpers.arrayElement([
        "Shopify",
        "WooCommerce",
        "Amazon",
        "Custom",
      ]),
      orderId: faker.string.numeric({
        length: faker.number.int({ min: 12, max: 12 }),
      }),
      bookingDate: faker.date.past().toISOString().split("T")[0],
      shippingId: faker.string.numeric({
        length: faker.number.int({ min: 12, max: 12 }),
      }),
      product: faker.commerce.product(),
      payment: faker.finance.amount(),
      paymentMode: faker.helpers.arrayElement(["COD", "Prepaid"]),
      customer: faker.person.fullName(),
      status: faker.helpers.arrayElement([
        "Booked",
        "Pending Pickup",
        "In-Transit",
        "Out for Delivery",
        "Delivered",
        "Cancelled",
        "Lost",
        "Damaged",
        "RTO All",
        "RTO In-Transit",
        "RTO Delivered",
        "RTO Lost",
      ]),
      carrier: faker.helpers.arrayElement([
        "Delhivery",
        "XpressBees",
        "Blue Dart",
        "Ecom Express",
        "DTDC",
        "Shadowfax",
        "India Post",
        "Gati",
        "Wow Express",
        "DHL India",
        "FedEx",
        "DHL",
        "UPS",
        "Aramex",
        "TNT Express",
        "Amazon Logistics",
        "Ekart Logistics",
        "Shadowfax",
        "Vulcan Express",
      ]),
      weight:
        faker.number.float({ min: 0.5, max: 10, precision: 0.01 }).toFixed(2) +
        " kg", // weight in kg
    };
  });
};

export const getNdrOrderData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      id: index + 1,
      channel: faker.helpers.arrayElement([
        "Shopify",
        "WooCommerce",
        "Amazon",
        "Custom",
      ]),
      orderId: 1000000000 + index, // Generates a 12-digit numeric Order ID
      bookingDate: faker.date.past().toISOString().split("T")[0],
      shippingId: faker.string.numeric({
        length: faker.number.int({ min: 12, max: 12 }),
      }),
      awbId: faker.string.numeric({
        length: faker.number.int({ min: 12, max: 12 }),
      }),
      payment: faker.finance.amount(),
      paymentMode: faker.helpers.arrayElement(["COD", "Prepaid"]),
      customer: faker.person.fullName(),
      ndrStatus: faker.helpers.arrayElement([
        "Action Required",
        "Action Requested",
        "Delivered",
        "RTO",
      ]),
      status: faker.helpers.arrayElement([
        "Pending",
        "In Transit",
        "Out for Delivery",
        "Delivered",
        "Cancelled",
        "Lost",
        "Damaged",
        "RTO All",
        "RTO In-Transit",
        "RTO Delivered",
        "RTO Lost",
      ]),
      carrier: faker.helpers.arrayElement([
        "Delhivery",
        "XpressBees",
        "Blue Dart",
        "Ecom Express",
      ]),
      exceptionInfo: faker.helpers.arrayElement([
        "Invalid Address",
        "Incomplete Address",
        "Pincode Mismatch",
        "Remote Area - Delivery Not Available",
        "Customer Not Available",
        "Security Restriction",
        "Package Refused by Customer",
        "Payment Declined",
        "COD Not Available",
        "Damaged Item",
        "Wrong Item Received",
        "Missing Items in Order",
        "Invalid Phone Number",
        "Customer Not Responding",
        "Delivery Rescheduled by Customer",
        "Shipment Lost in Transit",
        "Held at Customs",
        "Return to Origin Initiated",
        "Delivery Delayed due to Weather",
      ]),
    };
  });
};

export const getCodRemittanceData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      id: index + 1,
      sNo: index + 1,
      remittanceId: faker.string.numeric({
        length: faker.number.int({ min: 12, max: 12 }),
      }),
      codAmount: faker.finance.amount({
        min: 10,
        max: 1000,
      }),
      paymentDate: faker.date.past().toISOString().split("T")[0],
      walletPayment: faker.finance.amount({
        min: 10,
        max: 1000,
      }),
      accountPayment: faker.finance.amount({
        min: 10,
        max: 1000,
      }),
      utrReference: faker.finance.routingNumber(),
    };
  });
};

export const getWalletTransactionData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    const hasCredit = Math.random() > 0.5;
    const creditAmount = hasCredit
      ? parseFloat(faker.finance.amount(100, 10000, 2))
      : null;
    const debitAmount = !hasCredit
      ? parseFloat(faker.finance.amount(100, 10000, 2))
      : null;

    return {
      sNo: index + 1,
      shippingId: faker.string.numeric(12), // Generates a 12-digit numeric string
      date: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
      utrReference: faker.finance.routingNumber(),
      credit: hasCredit ? creditAmount : "---",
      debit: hasCredit ? "---" : debitAmount,
      closingBalance: hasCredit ? creditAmount : debitAmount ? -debitAmount : 0,
      description: faker.helpers.arrayElement(["COD", "Wallet"]),
    };
  });
};

export const getShippingChargeData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      sNo: index + 1,
      date: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
      shippingId: faker.string.numeric(12), // Generates a 12-digit numeric string
      courierPartner: faker.helpers.arrayElement([
        "Shopify",
        "WooCommerce",
        "Amazon",
        "Custom",
      ]),
      productName: faker.commerce.productName(),
      status: faker.helpers.arrayElement(["In-Transit"]),
      freightCharges: faker.finance.amount({ min: 10, max: 100 }),
      codCharges: faker.finance.amount({ min: 10, max: 100 }),
      weight:
        faker.number.float({ min: 0.5, max: 10, precision: 0.01 }).toFixed(2) +
        " kg",
      dimension: faker.helpers.arrayElement([
        "10x10x10",
        "20x20x20",
        "30x30x30",
        "40x40x40",
        "50x50x50",
      ]),
      appliedWeight:
        faker.number.float({ min: 0.5, max: 10, precision: 0.01 }).toFixed(2) +
        " kg",
      extraWeightCharges: faker.finance.amount({ min: 10, max: 100 }),
      codChargesReversed: faker.finance.amount({ min: 10, max: 100 }),
      rtoExtraWeightCharges: faker.finance.amount({ min: 10, max: 100 }),
      total: faker.finance.amount(),
    };
  });
};

export const getInvoiceData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      invoiceNo: `${faker.string.alpha({ length: 2 }).toUpperCase()}${String(index + 1).padStart(6, "0")}`,
      invoiceDate: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
      invoicePeriod: `${faker.date.past().toLocaleString("default", { month: "long" })} ${faker.date.past().getFullYear()}`,
      invoiceAmount: faker.finance.amount(),
    };
  });
};

export const getCreditNoteData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      creditNo: `${faker.string.alpha({ length: 2 }).toUpperCase()}${String(index + 1).padStart(6, "0")}`,
      creditDate: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
      creditPeriod: `${faker.date.past().toLocaleString("default", { month: "long" })} ${faker.date.past().getFullYear()}`,
      creditAmount: faker.finance.amount(),
    };
  });
};

export const getWeightDisputeData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      id: index + 1,
      applyWeightDate: faker.date.past().toISOString().split("T")[0],
      enteredWeight: `${faker.number.float({ min: 0.5, max: 10, precision: 0.01 }).toFixed(2)} kg`,
      dimension: faker.helpers.arrayElement([
        "10x10x10",
        "20x20x20",
        "30x30x30",
        "40x40x40",
        "50x50x50",
      ]),
      appliedWeight: `${faker.number.float({ min: 0.5, max: 10, precision: 0.01 }).toFixed(2)} kg`,
      shippingId: faker.string.numeric(12),
      product: faker.commerce.product(),
      shippingCharge: faker.finance.amount({ min: 10, max: 100 }),
      courier: faker.helpers.arrayElement([
        "Delhivery",
        "XpressBees",
        "Blue Dart",
        "Ecom Express",
        "DTDC",
        "Shadowfax",
        "India Post",
        "Gati",
        "Wow Express",
        "DHL India",
        "FedEx",
        "DHL",
        "UPS",
        "Aramex",
        "TNT Express",
        "Amazon Logistics",
        "Ekart Logistics",
        "Shadowfax",
        "Vulcan Express",
      ]),
      awbs: faker.string.numeric(12),
      action: faker.helpers.arrayElement(["Dispute Raise", "No Action Taken"]),
    };
  });
};

export const getPickupAddressData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      id: index + 1,
      Name: faker.person.fullName(),
      mobile: faker.string.numeric(10),
      pickAddress: faker.location.streetAddress(),
      city: faker.location.city(),
      pincode: faker.string.numeric(6),
    };
  });
};

export const getEmployeeLoginData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      id: index + 1,
      Name: faker.person.fullName(),
      mobile: faker.string.numeric(10),
      mail: faker.internet.email(),
      password: faker.internet.password(),
      permission: faker.helpers.arrayElement(["NDR, Tracking, Support"]),
    };
  });
};

export const getShippingIdData = (count = 100) => {
  return Array.from({ length: count }, () => {
    const isUsed = Math.random() > 0.5; // Randomly determine if the ID is used

    return {
      usedShippingId: isUsed ? faker.string.numeric(12) : "---------",
      unusedShippingId: isUsed ? "---------" : faker.string.numeric(12),
      status: isUsed ? "used" : "unused", // For tab filtering
    };
  });
};

export const getEscalationData = (count = 100) => {
  return Array.from({ length: count }, () => {
    return {
      escalationId: faker.string.numeric(12),
      Date: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
      status: faker.helpers.arrayElement([
        "All",
        "New",
        "In Progress",
        "Resolved",
      ]),
      shippingId: faker.string.numeric(12),
      shipmentStatus: faker.helpers.arrayElement([
        "Booked",
        "Pending Pickup",
        "In-Transit",
        "Out for Delivery",
        "Delivered",
        "Cancelled",
        "Lost",
        "Damaged",
        "RTO ALL",
        "RTO In-Transit",
        "RTO Delivered",
        "RTO Lost",
      ]),
      escalationStatus: faker.helpers.arrayElement([
        "pickupDelivery",
        "shipmentNdrRto",
        "shipmentDispute",
        "finance",
        "kycBankVerification",
        "technicalSupport",
        "billingTaxation",
        "claims",
        "other",
      ]),
    };
  });
};

export const getCourierPerformanceData = (count = 100) => {
  return Array.from({ length: count }, (_, index) => {
    return {
      sNo: index + 1,
      courier: faker.helpers.arrayElement([
        "Delhivery",
        "XpressBees",
        "Blue Dart",
        "Ecom Express",
      ]),
      totalShipment: faker.number.int({ min: 1, max: 1000 }),
      booked: faker.number.int({ min: 1, max: 1000 }),
      pending: faker.number.int({ min: 1, max: 1000 }),
      inTransit: faker.number.int({ min: 1, max: 1000 }),
      delivered: faker.number.int({ min: 1, max: 1000 }),
      rto: faker.number.int({ min: 1, max: 1000 }),
      lostDamage: faker.number.int({ min: 1, max: 1000 }),
    };
  });
};

// Options for States dropdown
export const StatesOptions = {
  AN: "Andaman and Nicobar Islands",
  AP: "Andhra Pradesh",
  AR: "Arunachal Pradesh",
  AS: "Assam",
  BR: "Bihar",
  CH: "Chandigarh",
  CT: "Chhattisgarh",
  DN: "Dadra and Nagar Haveli",
  DD: "Daman and Diu",
  DL: "Delhi",
  GA: "Goa",
  GJ: "Gujarat",
  HR: "Haryana",
  HP: "Himachal Pradesh",
  JK: "Jammu and Kashmir",
  JH: "Jharkhand",
  KA: "Karnataka",
  KL: "Kerala",
  LA: "Ladakh",
  LD: "Lakshadweep",
  MP: "Madhya Pradesh",
  MH: "Maharashtra",
  MN: "Manipur",
  ML: "Meghalaya",
  MZ: "Mizoram",
  NL: "Nagaland",
  OR: "Odisha",
  PY: "Puducherry",
  PB: "Punjab",
  RJ: "Rajasthan",
  SK: "Sikkim",
  TN: "Tamil Nadu",
  TG: "Telangana",
  TR: "Tripura",
  UP: "Uttar Pradesh",
  UT: "Uttarakhand",
  WB: "West Bengal",
};

export const statesOptionsArray = Object.keys(StatesOptions).map((key) => ({
  label: StatesOptions[key],
  value: key,
}));
export const getStateLabel = (value) => {
  return StatesOptions[value] || value;
};
export const getStateKey = (value) => {
  // Find the key in StatesOptions where the value matches
  const stateKey = Object.entries(StatesOptions).find(
    ([key, val]) => val === value,
  )?.[0];
  return stateKey || value;
};

export const escalationTypes = [
  { label: "Pickup", value: "pickup" },
  { label: "Pre Delivery", value: "preDelivery" },
  { label: "Post Delivery", value: "postDelivery" },
  { label: "RTO", value: "rto" },
  { label: "Claim", value: "claims" },
  { label: "Finance", value: "finance" },
  { label: "KYC", value: "kyc" },
  { label: "Technical Support", value: "technicalSupport" },
  { label: "Other", value: "other" },
];

export const getEscalationTypeLabel = (value) => {
  const escalationType = escalationTypes.find((type) => type.value === value);
  return escalationType?.label || value;
};

export const subcategoryOptions = [
  // Pickup
  {
    label: "Pickup Delayed / Not Done",
    value: "pickupDelayedNotDone",
    category: "pickup",
    shippingIdMandatory: true,
  },
  {
    label: "Physical Pickup Done but Status Not Updated",
    value: "physicalPickupDoneButStatusNotUpdated",
    category: "pickup",
    shippingIdMandatory: false,
  },
  {
    label: "Pickup Scanning / Label Issue",
    value: "pickupScanningLabelIssue",
    category: "pickup",
    shippingIdMandatory: false,
  },

  // Pre Delivery
  {
    label: "Delay in Delivery",
    value: "delayInDelivery",
    category: "preDelivery",
    shippingIdMandatory: true,
  },
  {
    label: "Fake Remark by Delivery Boy",
    value: "fakeRemarkByDeliveryBoy",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Behavior Complaint Against Staff",
    value: "behaviorComplaintAgainstStaff",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Delivery OTP Not Received",
    value: "deliveryOtpNotReceived",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Self-Collect – Branch Address Required",
    value: "selfCollectBranchAddressRequired",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Update Mobile Number",
    value: "updateMobileNumber",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Reattempt Delivery",
    value: "reattemptDelivery",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Shipment Misrouted",
    value: "shipmentMisrouted",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Urgent Delivery",
    value: "urgentDelivery",
    category: "preDelivery",
    shippingIdMandatory: false,
  },
  {
    label: "Tracking Status Not Updating for Shipment",
    value: "trackingStatusNotUpdatingForShipment",
    category: "preDelivery",
    shippingIdMandatory: false,
  },

  // Post Delivery
  {
    label: "Need POD",
    value: "needPod",
    category: "postDelivery",
    shippingIdMandatory: true,
  },
  {
    label: "Shipment Marked Delivered but Not Received by Customer",
    value: "shipmentMarkedDeliveredButNotReceivedByCustomer",
    category: "postDelivery",
    shippingIdMandatory: false,
  },
  {
    label:
      "Shipment Received by Customer but Not Marked Delivered in the System",
    value: "shipmentReceivedByCustomerButNotMarkedDeliveredInSystem",
    category: "postDelivery",
    shippingIdMandatory: false,
  },

  // RTO
  {
    label: "Cancel and Return Shipment to Seller",
    value: "cancelAndReturnShipmentToSeller",
    category: "rto",
    shippingIdMandatory: true,
  },
  {
    label:
      "Shipment Marked RTO Delivered but Not Physically Received by Seller",
    value: "shipmentMarkedRtoDeliveredButNotPhysicallyReceivedBySeller",
    category: "rto",
    shippingIdMandatory: false,
  },

  // Claim
  {
    label: "Damage in Delivered / RTO Shipment",
    value: "damageInDeliveredRtoShipment",
    category: "claims",
    shippingIdMandatory: true,
  },
  {
    label: "Product Missing in Delivered / RTO Shipment",
    value: "productMissingInDeliveredRtoShipment",
    category: "claims",
    shippingIdMandatory: false,
  },
  {
    label: "Mismatch in Delivered / RTO Shipment",
    value: "mismatchInDeliveredRtoShipment",
    category: "claims",
    shippingIdMandatory: false,
  },
  {
    label: "Rate / Zone Dispute",
    value: "rateZoneDispute",
    category: "claims",
    shippingIdMandatory: false,
  },
  {
    label: "Lost / Damaged Shipment Claim Not Received",
    value: "lostDamagedShipmentClaimNotReceived",
    category: "claims",
    shippingIdMandatory: false,
  },
  {
    label: "Other Claim-Related Queries",
    value: "otherClaimRelatedQueries",
    category: "claims",
    shippingIdMandatory: false,
  },

  // Finance
  {
    label: "Delay in COD Remittance",
    value: "delayInCodRemittance",
    category: "finance",
    shippingIdMandatory: false,
  },
  {
    label: "Recharge Done but Not Credited to Wallet",
    value: "rechargeDoneButNotCreditedToWallet",
    category: "finance",
    shippingIdMandatory: false,
  },
  {
    label: "Request Wallet Recharge from COD Amount",
    value: "requestWalletRechargeFromCodAmount",
    category: "finance",
    shippingIdMandatory: false,
  },
  {
    label: "Other Finance-Related Queries",
    value: "otherFinanceRelatedQueries",
    category: "finance",
    shippingIdMandatory: false,
  },
  {
    label: "TDS Query",
    value: "tdsQuery",
    category: "finance",
    shippingIdMandatory: false,
  },
  {
    label: "GST Invoice / Credit Note Query",
    value: "gstInvoiceCreditNoteQuery",
    category: "finance",
    shippingIdMandatory: false,
  },

  // KYC
  {
    label: "KYC Verification Pending",
    value: "kycVerificationPending",
    category: "kyc",
    shippingIdMandatory: false,
  },
  {
    label: "Change Bank Account Details for COD",
    value: "changeBankAccountDetailsForCod",
    category: "kyc",
    shippingIdMandatory: false,
  },
  {
    label: "Update GST Details",
    value: "updateGstDetails",
    category: "kyc",
    shippingIdMandatory: false,
  },
  {
    label: "Update Firm Logo",
    value: "updateFirmLogo",
    category: "kyc",
    shippingIdMandatory: false,
  },

  // Technical Support
  {
    label: "Unable to Manifest Shipment / Create Order",
    value: "unableToManifestShipmentCreateOrder",
    category: "technicalSupport",
    shippingIdMandatory: false,
  },
  {
    label: "API / Plugin Integration",
    value: "apiPluginIntegration",
    category: "technicalSupport",
    shippingIdMandatory: false,
  },
  {
    label: "Unable to Recharge Wallet",
    value: "unableToRechargeWallet",
    category: "technicalSupport",
    shippingIdMandatory: false,
  },
  {
    label: "Request Panel Training",
    value: "requestPanelTraining",
    category: "technicalSupport",
    shippingIdMandatory: false,
  },
  {
    label: "Issue with Shipping Label",
    value: "issueWithShippingLabel",
    category: "technicalSupport",
    shippingIdMandatory: false,
  },
  {
    label: "Other Technical Issues",
    value: "otherTechnicalIssues",
    category: "technicalSupport",
    shippingIdMandatory: false,
  },

  // Other
  {
    label: "Require Additional Support",
    value: "requireAdditionalSupport",
    category: "other",
    shippingIdMandatory: false,
  },
];

export const getSubcategoryLabel = (value) => {
  const subcategory = subcategoryOptions.find(
    (option) => option.value === value,
  );
  return subcategory?.label || value;
};

export const getSubcategoriesByCategory = (category) => {
  return subcategoryOptions.filter((option) => option.category === category);
};

export const isShippingIdMandatory = (subcategoryValue) => {
  const subcategory = subcategoryOptions.find(
    (option) => option.value === subcategoryValue,
  );
  return subcategory?.shippingIdMandatory || false;
};
